import { Modal } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';

export const TradeRule = ({ visble, onCancel }) => {
  const fm = useFm();
  return (
    <Modal
      open={visble}
      title={fm('tradeRuleGuide')}
      footer={null}
      onCancel={onCancel}
    >
      <h3 className="text-lg font-semibold">{fm('tradeRuleTitle')}</h3>
      <p
        className="text-sm text-gray-t2 mt-1"
        dangerouslySetInnerHTML={{
          __html: fm('tradeRuleDesc').replace(/\\n/g, '<br />'),
        }}
      ></p>
    </Modal>
  );
};
